import { useTranslation } from '@lt/localization';
import React, { useState } from 'react';
import styled from 'styled-components';
import type { PropsFromRedux } from '.';
import JointOrderCheckbox from './components/JointOrderCheckbox';
import SwitchOrder from './components/SwitchOrder';
import { JOINT_STATES } from './constants';
import type { JointState } from './types';
import { isCheckboxChecked } from './utils';

const JointOrder = (props: PropsFromRedux): JSX.Element => {
  const {
    isMobile,
    ordersAmount,
    setOrdersAmount,
    firstOrder,
    setFirstOrder,
    switchOrder,
    setFirstOrderField,
  } = props;
  const [jointState, setJointState] = useState<JointState>(
    JOINT_STATES.NOT_JOINT,
  );
  const { t } = useTranslation();
  const title = t('checkout.services.jointOrder.title');
  return (
    <StyledJointOrderWrapper $isMobile={isMobile}>
      <StyledTitle $isMobile={isMobile}>{title}</StyledTitle>
      <StyledJointOrderContainer $isMobile={isMobile}>
        <JointOrderCheckbox
          jointState={jointState}
          setJointState={setJointState}
          isMobile={isMobile}
        />
        {isCheckboxChecked(jointState) && (
          <SwitchOrder
            jointState={jointState}
            setJointState={setJointState}
            isMobile={isMobile}
            ordersAmount={ordersAmount}
            setOrdersAmount={setOrdersAmount}
            firstOrder={firstOrder}
            setFirstOrder={setFirstOrder}
            switchOrder={switchOrder}
            setFirstOrderField={setFirstOrderField}
          />
        )}
      </StyledJointOrderContainer>
    </StyledJointOrderWrapper>
  );
};

const StyledJointOrderWrapper = styled.div<{ $isMobile: boolean }>`
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  ${({ $isMobile }) =>
    $isMobile
      ? `gap: 8px;`
      : `
      width: 100%; 
      gap: 16px;
  `}
  align-self: stretch;
`;

const StyledTitle = styled.h2<{ $isMobile }>`
  font-size: ${({ $isMobile }) => ($isMobile ? `18px;` : `22px;`)}
  font-weight: 700;
  color: #17181a;
  padding: 0 8px;
  line-height: 26px;
`;

const StyledJointOrderContainer = styled.div<{ $isMobile: boolean }>`
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;

  border-radius: 4px;
  background: #fff;
  box-shadow: 0px 10px 15px 0px rgba(216, 214, 204, 0.9),
    0px 1px 2px 0px rgba(210, 208, 197, 0.9);
`;

export default JointOrder;
